import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "../assets/css/testimonials.css";

const Testimonials = () => {

    const testimonials = [
        {
            name: "NIKHIL PATEL",
            role: "Customer",
            text: "The consistency of their resin batches has helped our plywood production become smoother. Excellent quality, competitive pricing, and trustworthy long-term partnership"
        },
        {
            name: "ARJUN SOLANKI",
            role: "Customer",
            text: "I highly recommend Krishna Chemicals & Polymer for dependable resin solutions. Their products meet our standards, and their support team responds quickly and helps us solve challenges."
        },
        {
            name: "RAHUL SHAH",
            role: "Customer",
            text: "Reliable supply, excellent bonding strength, and professional technical support. Their resin quality has improved our production efficiency."
        }
    ];

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 2,
        },
        tablet: {
            breakpoint: { max: 1024, min: 640 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 640, min: 0 },
            items: 1,
        },
    };

    return (
        <section className="testimonials-wrapper">
            <div className="testimonials-container">

                <span className="section-tag">TESTIMONIALS</span>

                <h2>
                    Trusted by Manufacturers
                    <br />
                    Across India
                </h2>

                <Carousel
                    responsive={responsive}
                    infinite
                    arrows
                    showDots
                    swipeable
                    draggable
                    keyBoardControl
                    containerClass="testimonial-carousel"
                    dotListClass="testimonial-dots"
                    itemClass="testimonial-item"
                    removeArrowOnDeviceType={["mobile"]}
                >
                    {testimonials.map((item, index) => (
                        <div className="card" key={index}>
                            <span className="quote">“</span>

                            <p>{item.text}</p>

                            <div className="user">
                                <div className="avatar"></div>
                                <div>
                                    <strong>{item.name}</strong>
                                    <span>{item.role}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </Carousel>

            </div>
        </section>
    );
};

export default Testimonials;
